import React from 'react';
import { useGate } from 'statsig-react';
import { useParams } from '@context/params';
import { FEATURE_GATES } from '@utils/constants';
import { ExploreResults } from '../ExploreResults';
import { ChartsSection } from './ChartsSection';
import { ExploreMoreSection } from './ExploreMoreSection';
import { MoreSection } from './More';
import { SoundsByGenres } from './SoundsByGenres';

export const ExplorePage = () => {
  const { explore_type } = useParams();

  const { value: pointsEnabled } = useGate(FEATURE_GATES.SOCIALS_POINTS);
  return (
    <>
      {!!explore_type ? (
        <ExploreResults />
      ) : (
        <div className="mb-12 flex flex-col gap-6 px-6 pb-10 md:mx-auto lg:max-w-7xl">
          {!!pointsEnabled ? (
            <>
              <SoundsByGenres />
              <MoreSection />
            </>
          ) : (
            <>
              <ChartsSection />
              <SoundsByGenres />
              <ExploreMoreSection />
            </>
          )}
        </div>
      )}
    </>
  );
};
